"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';
import 'react';
import styles from './ProgressBar.module.scss.mjs';
import clsx from 'clsx';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { ProgressBarValue } from './components/ProgressBarValue.mjs';
import { ProgressBarBar } from './components/ProgressBarBar.mjs';
import { ProgressBarLegend } from './components/ProgressBarLegend.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';

const ProgressBar = flowComponent("ProgressBar", (props) => {
  const {
    children,
    className,
    status = "info",
    showMaxValue,
    size = "m",
    segments,
    value,
    formatOptions,
    showLegend = true,
    maxValue,
    valueLabel,
    ...rest
  } = props;
  const rootClassName = clsx(
    className,
    styles.progressBar,
    styles[`size-${size}`],
    styles[status]
  );
  const propsContext = {
    Label: {
      className: styles.label,
      unstyled: true
    }
  };
  const segmentsTotalValue = segments ? segments.map((s) => s.value).reduce((a, b) => a + b, 0) : void 0;
  return /* @__PURE__ */ jsx(
    Aria.ProgressBar,
    {
      className: rootClassName,
      value: segmentsTotalValue ?? value,
      formatOptions,
      maxValue,
      ...rest,
      children: ({ percentage }) => /* @__PURE__ */ jsxs(PropsContextProvider, { props: propsContext, children: [
        children,
        /* @__PURE__ */ jsx(
          ProgressBarValue,
          {
            showMaxValue,
            maxValue,
            formatOptions,
            value: segmentsTotalValue ?? value,
            valueLabel
          }
        ),
        /* @__PURE__ */ jsx(
          ProgressBarBar,
          {
            percentage,
            segmentsTotalValue,
            segments
          }
        ),
        /* @__PURE__ */ jsx(
          ProgressBarLegend,
          {
            showLegend,
            segments,
            formatOptions
          }
        )
      ] })
    }
  );
});

export { ProgressBar, ProgressBar as default };
//# sourceMappingURL=ProgressBar.mjs.map
